import { FC, memo, ReactNode, useLayoutEffect, useRef, useState } from 'react';
import { Carousel, CarouselProps } from 'antd';
import * as Styled from './styles';
import { ChevronLeft } from 'icons/ChevronLeft';

const defaultSettings: CarouselProps = {
  dots: false,
  infinite: true,
  variableWidth: true,
  draggable: true,
  adaptiveHeight: false,
  rows: 1,
  slidesPerRow: 1,
  swipeToSlide: true,
  arrows: false,
  prevArrow: (
    <Styled.Arrow>
      <ChevronLeft />
    </Styled.Arrow>
  ),
  nextArrow: (
    <Styled.Arrow>
      <ChevronLeft />
    </Styled.Arrow>
  ),
  dotPosition: 'bottom'
};

interface CartSliderProps {
  sliderProps?: CarouselProps;
  height?: number;
  itemWidth: number;
  itemsCount: number;
  innerShadow?: {
    left?: boolean;
    right?: boolean;
  };
  children: ReactNode;
}

const defaultInnerShadow: CartSliderProps['innerShadow'] = {
  left: false,
  right: false
};

export const CartSlider: FC<CartSliderProps> = memo(
  ({
    sliderProps,
    height,
    itemWidth,
    itemsCount,
    innerShadow = defaultInnerShadow,
    children
  }) => {
    const sliderSettings = { ...defaultSettings, ...sliderProps };
    const shadowInner = { ...defaultInnerShadow, ...innerShadow };

    const sliderParentRef = useRef<HTMLDivElement>(null);
    const [slidesToShow, setSlidesToShow] = useState(0);

    useLayoutEffect(() => {
      if (sliderParentRef.current) {
        const a = Math.floor(sliderParentRef.current.clientWidth / itemWidth);
        // Show at least one slider element
        setSlidesToShow(a || 1);
      }
    }, [itemWidth]);

    return (
      <Styled.SliderWrapper
        ref={sliderParentRef}
        $hasDots={Boolean(sliderSettings.dots)}
        $innerShadowLeft={shadowInner.left}
        $innerShadowRight={shadowInner.right}
      >
        {slidesToShow > 0 && (
          <Carousel
            {...sliderSettings}
            slidesToScroll={1}
            slidesToShow={Math.min(slidesToShow, itemsCount)}
            style={{ height }}
          >
            {children}
          </Carousel>
        )}
      </Styled.SliderWrapper>
    );
  }
);
